<template>
  <div class="order-pages" :class="{ 'single-page': pagesPerSpread === 1, 'double-page': pagesPerSpread === 2 }">
    <div>Thumbnail size:</div>
    <vue-slider v-model="sizeInPixels" :min="50" :max="1000" @change="sliderChange"></vue-slider>
    <div class="mb-8"></div>
    <draggable v-model="orderedPages" @end="end">
      <transition-group name="page">
        <div class="page" v-for="page in orderedPages" :key="page.id">
          <router-link :to="editPage(album, page.id)">
            <img
              class="image albumthumb border hover:border-gray-600 border-solid"
              :src="getThumbnailUrl(page)"
              :style="{ width: sizeInPixels + 'px' }"
            />
          </router-link>
          <button @click="deletePage(page)" class="deleteicon"><i class="fa fa-trash" aria-hidden="true"></i></button>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { orderPages } from '../utils'
import { editPage } from '../utils/routing'
import { getThumbnailUrl } from '../utils/image'

const localStorageKey = 'scrapbook-share.order-pages.sizeInPixels'

export default {
  props: ['pages', 'order', 'updatePageOrder', 'pagesPerSpread', 'deletePage', 'album'],
  data() {
    return {
      orderedPages: orderPages(this.pages, this.order),
      sizeInPixels: this.$localStorage.get(localStorageKey, 100),
    }
  },
  components: {
    draggable,
  },
  watch: {
    pages() {
      this.orderedPages = orderPages(this.pages, this.order)
    },
    order() {
      this.orderedPages = orderPages(this.pages, this.order)
    }
  },
  methods: {
    end() {
      this.updatePageOrder(this.orderedPages.map(x => x.id))
    },
    editPage,
    sliderChange(value) {
      this.$localStorage.set(localStorageKey, value)
    },
    getThumbnailUrl(page) {
      return getThumbnailUrl(page)
    },
  },
}
</script>

<style lang="stylus" scoped>
.page
  display inline-block
  cursor grab
  transition opacity .7s

  &-enter, &-leave-active
    opacity 0

  img
    position relative
    display block

  button.deleteicon
    color #333
    background none
    position relative
    display block
    float right
    padding 5px 0 0 0

.single-page .page
  padding 0 35px 30px 0

.double-page .page
  &:nth-child(odd)
    padding 0 5px 30px 0

  &:nth-child(even)
    padding 0 50px 30px 0

.image
  position relative

.sortable-ghost
  opacity .1
</style>
